
import PaginationType from "@/types/Pagination";
import Product from "@/types/Product";
import { defineComponent, onMounted, onUnmounted, PropType, ref } from "vue";
import { DynamicScroller } from "vue-virtual-scroller";
import Pagination from "../General/Pagination.vue";
import Card from "../General/Card.vue";
import Button from "../Buttons/Button.vue";
import { mdiLoading, mdiTagText } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import PrintPriceTags from "./PrintPriceTags.vue";
import ProductActions from "./ProductActions.vue";
import { Inertia } from "@inertiajs/inertia";
import { debounce, throttle } from "lodash";
import { Link } from "@inertiajs/inertia-vue3";

export default defineComponent({
  components: {
    Link,
    DynamicScroller,
    Pagination,
    Card,
    Button,
    SvgIcon,
    PrintPriceTags,
    ProductActions,
  },
  props: {
    products: {
      type: Object as PropType<PaginationType<Product> | null | undefined>,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: () => false,
    },
    showPrintButton: {
      type: Boolean,
      default: () => true,
    },
    showWcId: {
      type: Boolean,
      default: () => true,
    },
    printMode: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props) {
    const getPercentProfit = (product: Product): number => {
      if (product.price <= 0) {
        return 0;
      }

      const something = 100 / product.price;

      const profitDividedBy100 = (product.price - product.cost) / 100;

      return something * profitDividedBy100 * 100;
    };

    const printPriceTagsOpen = ref(false);

    const showReload = ref(false);

    const reloadLoading = ref(false);

    const updateScrollPos = throttle((event: Event) => {
      // @ts-ignore
      showReload.value = event.target?.scrollTop > 600;
      //@ts-ignore
      console.log(event.target?.scrollTop);
    }, 250);

    onMounted(() => {
      const mainContainer = document.querySelector(".main-container");
      showReload.value = (mainContainer?.scrollTop ?? 0) > 600;
      mainContainer?.addEventListener("scroll", updateScrollPos);
    });

    onUnmounted(() => {
      document
        .querySelector(".main-container")
        ?.removeEventListener("scroll", updateScrollPos);
    });
    const paginationSize = ref();

    const checkSize = (event?: Event) => {
      paginationSize.value = "sm";
      console.log(window.innerWidth);

      if (window.innerWidth > 768) {
        paginationSize.value = "md";
      }

      if (window.innerWidth > 1080) {
        paginationSize.value = "lg";
      }
    };

    window.addEventListener("resize", debounce(checkSize, 250));

    checkSize();

    const reloadPage = () => {
      reloadLoading.value = true;

      console.log("Reloading the page");

      Inertia.reload({
        preserveScroll: true,
        onFinish: () => {
          reloadLoading.value = false;
        },
      });
    };

    onMounted(() => {
      /**
       * Using some smoking hot new browser features, so Typescript doesnt know what it is yet. (September 2022)
       */
      // @ts-ignore
      if (navigation) {
        // @ts-ignore
        const last = navigation.entries().at(-1);

        console.log({
          last,
        });

        if (last.url.includes("/l-products/view-product/")) {
          setTimeout(() => {
            reloadPage();
          }, 1000);
        }
      }
    });

    return {
      getPercentProfit,
      priceTagIcon: mdiTagText,
      printPriceTagsOpen,
      reloadPage,
      showReload,
      reloadLoading,
      loadingIcon: mdiLoading,
      paginationSize,
    };
  },
});
